import type { GetStaticProps } from 'next';

import { makeStaticPropsRequest } from '../modules/page-info';
import { makePage } from '../modules/page-info/page';
import { makePagePropsProvider } from '../modules/page-info/page-props-provider';
import type { PageProps } from '../modules/page-info/types';

export const getStaticProps: GetStaticProps<PageProps> = makeStaticPropsRequest(
  '/email-disclaimer',
  'No email disclaimer page entry found'
);

const PageComponent = makePage({ pageTitle: 'Email disclaimer' });
const EmailDisclaimerPage = makePagePropsProvider<typeof getStaticProps>(PageComponent);
export default EmailDisclaimerPage;
